const newData = [
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/blue-black-rimless-aviator-vincent-chase-sleek-steel-vc-e12421-c4-eyeglasses_g_774728_02_2022.jpg",
    ratingV: 4.7,
    ratingC: 150,
    name: "Vincent Chase Online",
    size: "Medium",
    tags: "Clean Cut",
    colorO: 2,
    dprice: 1700,
    OgPrice: 3000,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/Vincent-Chase-VC-E14326-C2-Eyeglasses_J_1949.jpg",
    ratingV: 4.8,
    ratingC: 20,
    name: "Vincent Chase Online",
    size: "Medium",
    tags: "Clean Cut",
    colorO: 2,
    dprice: 1700,
    OgPrice: 3000,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//j/o/john-jacobs-jj-e13570-fulll-rim-c1-eyeglaasses_G_8314.jpg",
    ratingV: 5,
    ratingC: 2,
    name: "John Jacobs Online",
    size: "Medium",
    tags: "John Jacobs",
    colorO: null,
    dprice: 3200,
    OgPrice: 4200,
    offer: "40% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/Black-Bronze-Black-Half-Rim-Round-Vincent-Chase-SLEEK-STEEL-VC-E11559-C6-Eyeglasses_vincent-chase-vc-e11559-c6-eyeglasses_G_825207_02_2022.jpg",
    ratingV: 4.5,
    ratingC: 167,
    name: "Vincent Chase Online",
    size: "Medium",
    tags: "Sleek Steel",
    colorO: 1,
    dprice: 1700,
    OgPrice: 3000,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/red-full-rim-cat-eye-vincent-chase-sleek-steel-vc-e14715-c3-eyeglasses_g_4073_9_july.jpg",
    ratingV: 5,
    ratingC: 8,
    name: "Vincent Chase Online",
    size: "Medium",
    tags: "Shine On",
    colorO: 3,
    dprice: 999,
    OgPrice: 5000,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//l/e/lenskart-air-lla-e13415-full-rim-ultem-c3-eyeglasses_g_9876_3.jpg",
    ratingV: 4.7,
    ratingC: 71,
    name: "Lenskart Air Online",
    size: "Medium",
    tags: "Air Flex",
    colorO: null,
    dprice: 999,
    OgPrice: 4000,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/vincent-chase-vc-e14267-c2-eyeglasses_G_3859.jpg",
    ratingV: 5,
    ratingC: 3,
    name: "Vincent Chase Online",
    size: "Wide",
    tags: "Urban Retro",
    colorO: 3,
    dprice: 999,
    OgPrice: 3000,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/vincent-chase-vc-e11785-c1-eyeglasses_vincent-chase-vc-e11785-c1-eyeglasses_g_6008_1_1.jpg",
    ratingV: 4.5,
    ratingC: 119,
    name: "Vincent Chase Online",
    size: "Medium",
    tags: "HD Acetate",
    colorO: 3,
    dprice: 999,
    OgPrice: null,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/Brown-Gold-Tortoise-Full-Rim-Square-Vincent-Chase-SLEEK-STEEL-VC-E12422-C5-Eyeglasses_vincent-chase-vc-e12422-c5-eyeglasses_G_933607_02_2022.jpg",
    ratingV: 4.7,
    ratingC: 510,
    name: "Vincent Chase Online",
    size: "Wide",
    tags: "Sleek Steel",
    colorO: 1,
    dprice: 999,
    OgPrice: null,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/vincent-chase-vc-e13051-foll-rim-sq-way-stl-c4-eyegasus_vincent-chase-vc-e13051-foll-rim-sq-way-stl-c4-eyegasus_g_8054_1.jpg",
    ratingV: 4.6,
    ratingC: 180,
    name: "Vincent Chase Online",
    size: "Extra Narrow",
    tags: "Sleek Steel",
    colorO: 1,
    dprice: 999,
    OgPrice: 3000,
    offer: "60% OFF. Use: EYECON",
  },
  {
    ratingV: 4.9,
    ratingC: 15,
    name: "Lenskart Air Online",
    size: "Wide",
    colorO: null,
    dprice: 999,
    OgPrice: 4000,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//j/i/brown-tortoise-rimless-rectangle-john-jacobs-pro-titanium-jj-e14685-c3-eyeglasses_csvfile-1646738947836-g_0613.jpg",
    ratingV: 4.7,
    ratingC: 3,
    name: "John Jacobs JJ",
    size: "Medium",
    tags: "John Jacobs",
    colorO: null,
    dprice: 3200,
    OgPrice: 4000,
    offer: "40% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//j/i/silver-sky-blue-full-rim-square-john-jacobs-supreme-steel-jj-e14693-c3-eyeglasses_g_2143_20_05_2022.jpg",
    ratingV: 5,
    ratingC: 2,
    name: "John Jacobs",
    size: "Wide",
    tags: "John Jacobs",
    colorO: null,
    dprice: 3200,
    OgPrice: 4000,
    offer: "40% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/vincent-chase-vc-e14106-c1-c1-eyeglasses_vincent-chase-vc-e14106-c1-c1-eyeglasses_vincent-chase-vc-e14106-c1-c1-eyeglasses_G_8494.jpg",
    ratingV: 3.8,
    ratingC: 12,
    name: "Vincent Chase Online",
    size: "Narrow",
    tags: "Retro",
    colorO: null,
    dprice: 999,
    OgPrice: null,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//j/i/John-Jacobs-JJ-E14369-C3-Eyeglasses_G_7597.jpg",
    ratingV: 5,
    ratingC: 4,
    name: "John Jacobs JJ",
    size: "Wide",
    tags: "John Jacobs",
    colorO: null,
    dprice: 3200,
    OgPrice: 4000,
    offer: "40% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/vincent-chase-vc-e13921-c1-eyeglasses_g_9041.jpg",
    ratingV: 4.4,
    ratingC: 8,
    name: "Vincent Chase Online",
    size: "Medium",
    tags: "Classic Acetate",
    colorO: 1,
    dprice: 999,
    OgPrice: null,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/gunmetal-black-half-rim-geometric-vincent-chase-sleek-steel-vc-e14439-c1-eyeglasses_g_8333.jpg",
    ratingV: 4.4,
    ratingC: 31,
    name: "Vincent Chase Online",
    size: "Medium",
    tags: "Color Block",
    colorO: 1,
    dprice: 1700,
    OgPrice: null,
    offer: "60% OFF. Use: EYECON",
  },
  {
    ratingV: 4.7,
    ratingC: 79,
    name: "Lenskart Air Online",
    size: "Wide",
    colorO: 1,
    dprice: 999,
    OgPrice: null,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/vincent-chase-vc-e14847-c2-eyeglasses_csvfile-1654498450302-g_4661.jpg",
    ratingV: 5,
    ratingC: 1,
    name: "Vincent Chase Online",
    size: "Extra Wide",
    tags: "Pride",
    colorO: null,
    dprice: 999,
    OgPrice: null,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/Green-Transparent-Full-Rim-Cat-Eye-Vincent-Chase-HD-Acetate-VC-E11785-S-C2-Eyeglasses_vincent-chase-vc-e11785-s-c2-eyeglasses_G_108807_02_2022.jpg",
    ratingV: 4.7,
    ratingC: 31,
    name: "Vincent Chase Online",
    size: "Narrow",
    tags: "HD Acetate",
    colorO: null,
    dprice: 999,
    OgPrice: null,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//l/i/Lenskart-Air-LA-E14359-C2-Eyeglasses_J_1817.jpg",
    ratingV: 4.8,
    ratingC: 41,
    name: "Lenskart Air Online",
    size: "Wide",
    tags: "Essential Edit",
    colorO: 1,
    dprice: 999,
    OgPrice: null,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/tortoise-black-full-rim-square-vincent-chase-classic-acetate-vc-e14723-c1-eyeglasses_g_843708_03_2022.jpg",
    ratingV: 4.5,
    ratingC: 2,
    name: "Vincent Chase Online",
    size: "Extra Wide",
    tags: "Classic Acetate",
    colorO: 1,
    dprice: 999,
    OgPrice: 4200,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/vincent-chase-vc-e14043-c3-eyeglasses_vincent-chase-vc-e14043-c3-eyeglasses_G_8656.jpg",
    ratingV: 4.9,
    ratingC: 31,
    name: "Vincent Chase Online",
    size: "Wide",
    tags: "Sleek Steel",
    colorO: null,
    dprice: 999,
    OgPrice: null,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/green-transparent-black-full-rim-geometric-vincent-chase-classic-acetate-vc-e14720-c3-eyeglasses_lenskart_alaya_152901_07_09_2022.jpg",
    ratingV: 4.8,
    ratingC: 6,
    name: "Vincent Chase Online",
    size: "Medium",
    tags: "Classic Acetate",
    colorO: 1,
    dprice: 999,
    OgPrice: 1299,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//j/o/john-jacobs-jj-e13911-c1-eyeglasses_john-jacobs-jj-e13911-c1-eyeglasses_G_4804.jpg",
    ratingV: 5,
    ratingC: 2,
    name: "John Jacobs Online",
    size: "Medium",
    tags: "John Jacobs",
    colorO: null,
    dprice: 6200,
    OgPrice: 7200,
    offer: "40% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//j/i/john-jacobs-jj-e14490-c1-eyeglasses_g_8060.jpg",
    ratingV: 5,
    ratingC: 1,
    name: "John Jacobs",
    size: "Medium",
    tags: "John Jacobs",
    colorO: null,
    dprice: 5200,
    OgPrice: 6000,
    offer: "40% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/vincent-chase-vc-e13477-fyll-rim-wfr-acetete-c3-eyeglasses_g_0676.jpg",
    ratingV: 4.3,
    ratingC: 112,
    name: "Vincent Chase Online",
    size: "Wide",
    tags: "Classic Acetate",
    colorO: 1,
    dprice: 999,
    OgPrice: null,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//j/i/Black-Red-Full-Rim-Round-John-Jacobs-TR-Flex-JJ%EF%BF%BD%EF%BF%BDE11926-C3-Eyeglasses_john-jacobs-jj-e11926-c3-full-rim-eyeglasses_G_598414_02_2022.jpg",
    ratingV: 4.4,
    ratingC: 131,
    name: "John Jacobs JJ",
    size: "Medium",
    tags: "John Jacobs",
    colorO: null,
    dprice: 3200,
    OgPrice: 4000,
    offer: "40% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//l/e/lenskart-air-la-e14187-c3-eyeglasses_lenskart-air-la-e14187-c3-eyeglasses_G_9084.jpg",
    ratingV: 4.7,
    ratingC: 73,
    name: "Lenskart Air Online",
    size: "Medium",
    colorO: 3,
    dprice: 999,
    OgPrice: null,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//l/i/lenskart-air-la-e14589-c1-eyeglasses_g_882523_02_2022.jpg",
    ratingV: 4.4,
    ratingC: 31,
    name: "Lenskart Air Online",
    size: "Medium",
    tags: "Air Classic",
    colorO: 1,
    dprice: 999,
    OgPrice: 4000,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//l/e/lenskart-air-la-e13267-c11-eyeglass_lenskart-air-la-e13267-c11-dup-eyeglass_lenskart-air-la-e13267-c11-eyeglass_g_9108.jpg",
    ratingV: 4.6,
    ratingC: 50,
    name: "Lenskart Air Online",
    size: "Narrow",
    tags: "Air Flex",
    colorO: null,
    dprice: 999,
    OgPrice: 3000,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//l/e/lenskart-air-la-e13058-c1-eyeglasses_eyeglasses_g_2590_1_1.jpg",
    ratingV: 4.5,
    ratingC: 80,
    name: "Lenskart Air Online",
    size: "Extra Wide",
    colorO: null,
    dprice: 999,
    OgPrice: null,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/vincent-chase-vc-e14383-c1-eyeglasses_G_8021.jpg",
    ratingV: 4.9,
    ratingC: 7,
    name: "Vincent Chase Online",
    size: "Narrow",
    tags: "Urban Retro",
    colorO: 1,
    dprice: 999,
    OgPrice: 4000,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//l/i/Gunmetal-Black-Rimless-Aviator-Lenskart-AIR-Classic-LA-E13065-C2-Eyeglasses_lenskart-air-la-e13065-c2-eyeg_eyeg_g_7839_1_10_02_2022.jpg",
    ratingV: 4.5,
    ratingC: 129,
    name: "Lenskart Air Online",
    size: "Medium",
    tags: "Air Classic",
    colorO: null,
    dprice: 1700,
    OgPrice: 3000,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//l/e/lenskart-air-la-e14395-c2-eyeglasses_g_7084.jpg",
    ratingV: 4.6,
    ratingC: 36,
    name: "Lenskart Air Online",
    size: "Medium",
    tags: "Air Flex",
    colorO: 1,
    dprice: 999,
    OgPrice: 7200,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//l/e/lenskart-air-la-e14019-c1-eyeglasses_G_4224.jpg",
    ratingV: 4.8,
    ratingC: 52,
    name: "Lenskart Air Online",
    size: "Medium",
    tags: "Air Flex",
    colorO: 2,
    dprice: 1700,
    OgPrice: 3000,
    offer: "60% OFF. Use: EYECON",
  },
  {
    ratingV: 4.6,
    ratingC: 141,
    name: "Lenskart Air Online",
    size: "Wide",
    colorO: 1,
    dprice: 999,
    OgPrice: 4200,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//l/e/lenskart-air-lla-e13414-full-rim-ultem-c3-eyeglasses_G_8238_2.jpg",
    ratingV: 4.6,
    ratingC: 52,
    name: "Lenskart Air Online",
    size: "Medium",
    tags: "Air Flex",
    colorO: 1,
    dprice: 999,
    OgPrice: 5000,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/vincent-chase-vc-e12707-foll-rim-rnd-tr90ss-mtl-c3-eyegasus_g_2990.jpg",
    ratingV: 4.7,
    ratingC: 137,
    name: "Lenskart Air Online",
    size: "Extra Wide",
    tags: "Light Weight",
    colorO: null,
    dprice: 999,
    OgPrice: 3000,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//v/i/vincent-chase-vc-e14035-c1-eyeglasses_vincent-chase-vc-e14035-c1-eyeglasses_G_6350.jpg",
    ratingV: 4.7,
    ratingC: 47,
    name: "Vincent Chase Online",
    size: "Narrow",
    tags: "Sleek Steel",
    colorO: 1,
    dprice: 999,
    OgPrice: 4000,
    offer: "60% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//j/i/Blue-Transparent-Silver-Full-Rim-Square-John-Jacobs-Rich-Acetate-JJ-E13929-C2-Eyeglasses_john-jacobs-jj-e13929-c2-eyegglaassas_G_861216_02_2022.jpg",
    ratingV: 5,
    ratingC: 2,
    name: "John Jacobs Online",
    size: "Wide",
    tags: "John Jacobs",
    colorO: null,
    dprice: 4200,
    OgPrice: 5200,
    offer: "40% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//j/o/john-jacobs-jj-e13181-c1-eyeglasses_john-jacobs-jj-e13181-c1-eyeglasses_G_5960.jpg",
    ratingV: 4.5,
    ratingC: 11,
    name: "John Jacobs JJ",
    size: "Extra Wide",
    tags: "John Jacobs",
    colorO: null,
    dprice: 3200,
    OgPrice: null,
    offer: "40% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//j/i/pink-transparent-gold-pink-full-rim-square-john-jacobs-rich-acetate-jj-e14649-c2-eyeglasses_g_9453_16_03_2022.jpg",
    ratingV: 4.7,
    ratingC: 33,
    name: "John Jacobs Online",
    size: "Wide",
    tags: "John Jacobs",
    colorO: 1,
    dprice: 4200,
    OgPrice: 5200,
    offer: "40% OFF. Use: EYECON",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//j/o/john-jacobs-jj-e13555-c1-full-rim-ne1w-eyeglasses_G_3317.jpg",
    ratingV: 4.6,
    ratingC: 8,
    name: "John Jacobs JJ",
    size: "Wide",
    tags: "John Jacobs",
    colorO: null,
    dprice: 3200,
    OgPrice: 4000,
    offer: "40% OFF. Use: EYECON",
  },
];

export default newData;
